module.exports = __webpack_public_path__ + "img/nunito-sans-v11-latin-regular.8030e845.svg";